import { render, staticRenderFns } from "./CollectionCardSmall.vue?vue&type=template&id=314ae3ec&"
import script from "./CollectionCardSmall.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardSmall.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionCardSmall.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports